import { FREQUENCY, ONCE_SCHEDULE_DATE_OPTION } from '@flexible-reports/utils/schedule-constants';
import { PeriodPreset, ScheduleType, SortableField } from '@flexible-reports/store/api/subscriptions/types';
import { PRESET_PERIOD } from '@flexible-reports/components/date-input/utils/constants';
import { SUBSCRIPTION_TABLE_COLUMN_ID } from '@flexible-reports/pages/landing/subscriptions-table/column-configurations/column-id';
import { SORTING_ORDER } from '@amzn/unified-data-table-components/core';

export const timeZoneFromApiMap: { [key: string]: string } = {
  AMERICA_ANCHORAGE: 'America/Anchorage',
  AMERICA_CARACAS: 'America/Caracas',
  AMERICA_CHICAGO: 'America/Chicago',
  AMERICA_DENVER: 'America/Denver',
  AMERICA_HALIFAX: 'America/Halifax',
  AMERICA_LOS_ANGELES: 'America/Los_Angeles',
  AMERICA_NEW_YORK: 'America/New_York',
  AMERICA_MEXICO_CITY: 'America/Mexico_City',
  AMERICA_SAO_PAULO: 'America/Sao_Paulo',
  AMERICA_ST_JOHNS: 'America/St_Johns',
  ASIA_ALMATY: 'Asia/Almaty',
  ASIA_BAGHDAD: 'Asia/Baghdad',
  ASIA_BANGKOK: 'Asia/Bangkok',
  ASIA_DUBAI: 'Asia/Dubai',
  ASIA_HONG_KONG: 'Asia/Hong_Kong',
  ASIA_KABUL: 'Asia/Kabul',
  ASIA_KATHMANDU: 'Asia/Kathmandu',
  ASIA_KOLKATA: 'Asia/Kolkata',
  ASIA_MAGADAN: 'Asia/Magadan',
  ASIA_RIYADH: 'Asia/Riyadh',
  ASIA_SHANGHAI: 'Asia/Shanghai',
  ASIA_SINGAPORE: 'Asia/Singapore',
  ASIA_TEHRAN: 'Asia/Tehran',
  ASIA_TOKYO: 'Asia/Tokyo',
  ASIA_YEKATERINBURG: 'Asia/Yekaterinburg',
  ASIA_YEREVAN: 'Asia/Yerevan',
  ATLANTIC_AZORES: 'Atlantic/Azores',
  ATLANTIC_SOUTH_GEORGIA: 'Atlantic/South_Georgia',
  AUSTRALIA_BRISBANE: 'Australia/Brisbane',
  AUSTRALIA_DARWIN: 'Australia/Darwin',
  AUSTRALIA_SYDNEY: 'Australia/Sydney',
  EET: 'EET',
  EUROPE_AMSTERDAM: 'Europe/Amsterdam',
  EUROPE_ISTANBUL: 'Europe/Istanbul',
  EUROPE_LONDON: 'Europe/London',
  EUROPE_PARIS: 'Europe/Paris',
  EUROPE_STOCKHOLM: 'Europe/Stockholm',
  INDIAN_COCOS: 'Indian/Cocos',
  PACIFIC_FIJI: 'Pacific/Fiji',
  PACIFIC_HONOLULU: 'Pacific/Honolulu',
  PACIFIC_KWAJALEIN: 'Pacific/Kwajalein',
  PACIFIC_MIDWAY: 'Pacific/Midway',
  PACIFIC_AUCKLAND: 'Pacific/Auckland',
  UTC: 'UTC'
};

export const timeZoneToApiMap = Object.fromEntries(Object.entries(timeZoneFromApiMap).map(([key, value]) => [value, key]));

export const scheduleTypeToApiMap: { [key: string]: ScheduleType } = {
  [ONCE_SCHEDULE_DATE_OPTION.TODAY]: ScheduleType.NOW,
  [ONCE_SCHEDULE_DATE_OPTION.FUTURE]: ScheduleType.FUTURE,
  [FREQUENCY.DAILY]: ScheduleType.RECURRING_DAILY,
  [FREQUENCY.WEEKLY]: ScheduleType.RECURRING_WEEKLY,
  [FREQUENCY.MONTHLY]: ScheduleType.RECURRING_MONTHLY
};

export const periodPresetToApiMap: { [key: string]: PeriodPreset } = {
  [PRESET_PERIOD.THIS_MONTH]: PeriodPreset.MONTH_TO_DATE,
  [PRESET_PERIOD.THIS_WEEK]: PeriodPreset.WEEK_TO_DATE,
  [PRESET_PERIOD.THIS_QUARTER]: PeriodPreset.QUARTER_TO_DATE,
  [PRESET_PERIOD.THIS_YEAR]: PeriodPreset.YEAR_TO_DATE
};

export const periodPresetFromApiMap: { [key: string]: PRESET_PERIOD } = {
  [PeriodPreset.MONTH_TO_DATE]: PRESET_PERIOD.THIS_MONTH,
  [PeriodPreset.WEEK_TO_DATE]: PRESET_PERIOD.THIS_WEEK,
  [PeriodPreset.QUARTER_TO_DATE]: PRESET_PERIOD.THIS_QUARTER,
  [PeriodPreset.YEAR_TO_DATE]: PRESET_PERIOD.THIS_YEAR
};

export const LAST_DAY_OF_MONTH_PRESET = 'LAST_DAY_OF_MONTH';

export const sortFieldToApiMap: Record<string, string> = {
  [SUBSCRIPTION_TABLE_COLUMN_ID.STATE]: SortableField.STATE,
  [SUBSCRIPTION_TABLE_COLUMN_ID.REPORT_NAME]: SortableField.NAME,
  [SUBSCRIPTION_TABLE_COLUMN_ID.STATUS]: SortableField.STATUS,
  [SUBSCRIPTION_TABLE_COLUMN_ID.FREQUENCY]: SortableField.FREQUENCY,
  [SUBSCRIPTION_TABLE_COLUMN_ID.FILE_FORMAT]: SortableField.FORMAT,
  [SUBSCRIPTION_TABLE_COLUMN_ID.CREATED_DATE]: SortableField.CREATION_DATE,
  [SUBSCRIPTION_TABLE_COLUMN_ID.LAST_MODIFIED_DATE]: SortableField.LAST_UPDATED_DATE,
  [SUBSCRIPTION_TABLE_COLUMN_ID.REPORT_LAST_RUN]: SortableField.LAST_RUN_DATE,
  [SUBSCRIPTION_TABLE_COLUMN_ID.REPORT_NEXT_RUN]: SortableField.NEXT_RUN_DATE
};

export const sortDirectionToApiMap: Record<string, string> = {
  [SORTING_ORDER.ASC]: 'ASCENDING',
  [SORTING_ORDER.DESC]: 'DESCENDING'
};
